// themeUtils.ts
export const themeColors = {
  dark: {
    background: "#0B0B0F",
    card: "#1A1C1F",
    cardMuted: "#2A3441",
    border: "#2E2F33",
    cardLighter: "#3A4553",
    cardLightest: "#4A5463",
    goldFrom: "#FBD282",
    goldTo: "#B59143",
    text: "#FFFFFF",
    textMuted: "#C3C9D3",
  },
  light: {
    background: "#F8FAFC",
    card: "#FFFFFF",
    cardMuted: "#F2F4F7",
    border: "#E5E7EB",
    cardLighter: "#F9FAFB",
    cardLightest: "#F3F4F6",
    goldFrom: "#FBD282",
    goldTo: "#B59143",
    text: "#111827",
    textMuted: "#6B7280",
  },
};

export const getThemeClasses = (isDark: boolean) => {
  const colors = isDark ? themeColors.dark : themeColors.light;
  
  return {
    // Background classes
    background: isDark ? "bg-[#0B0B0F]" : "bg-[#F8FAFC]",
    card: isDark ? "bg-[#1A1C1F]" : "bg-white",
    cardMuted: isDark ? "bg-[#2A3441]" : "bg-[#F2F4F7]",
    cardLighter: isDark ? "bg-[#3A4553]" : "bg-[#F9FAFB]",
    cardLightest: isDark ? "bg-[#4A5463]" : "bg-[#F3F4F6]",
    
    // Border classes
    border: isDark ? "border-[#2E2F33]" : "border-[#E5E7EB]",
    
    // Text classes
    text: isDark ? "text-gray-300" : "text-gray-900",
    textMuted: isDark ? "text-gray-400" : "text-gray-600",
    
    // Gradient classes
    goldGradient: "bg-gradient-to-r from-[#FBD282] to-[#B59143]",
    goldGradientHover: "hover:from-[#E8C16C] hover:to-[#A7843D]",
    
    // Button classes
    primaryButton: `bg-gradient-to-r from-[#FBD282] to-[#B59143] text-white font-semibold hover:from-[#E8C16C] hover:to-[#A7843D] focus:ring-2 focus:ring-[#B59143] focus:ring-opacity-50 shadow-sm hover:shadow transition-all duration-200`,
    secondaryButton: isDark 
      ? "bg-[#2A3441] text-white border border-[#2E2F33] hover:bg-[#3A4553] focus:ring-2 focus:ring-[#B59143] focus:ring-opacity-50 transition-all duration-200"
      : "bg-white text-[#111827] border border-[#E5E7EB] hover:bg-[#FFF7E6] hover:border-[#E8C16C] text-[#B59143] focus:ring-2 focus:ring-[#B59143] focus:ring-opacity-40 transition-all duration-200",
    goldOutlineButton: isDark
      ? "bg-transparent text-[#FBD282] border border-[#B59143] hover:bg-[#1A1C1F] focus:ring-2 focus:ring-[#B59143] focus:ring-opacity-30 transition-all duration-200"
      : "bg-white text-[#B59143] border border-[#B59143] hover:bg-[#FFF7E6] focus:ring-2 focus:ring-[#B59143] focus:ring-opacity-30 transition-all duration-200",
    
    // Header specific classes
    headerGradient: isDark 
      ? "relative overflow-hidden bg-gradient-to-br from-[#0B0B0F] via-[#1A1C1F] to-[#0B0B0F] ring-1 ring-[#2E2F33] shadow-[inset_0_1px_0_rgba(251,210,130,0.08),inset_0_-1px_0_rgba(251,210,130,0.05),0_10px_28px_rgba(0,0,0,0.45)]"
      : "bg-gradient-to-r from-[#FFF7E6] via-[#FAEDD0] to-[#FFF8EA] shadow-[inset_0_-1px_0_0_rgba(229,231,235,0.7),0_2px_8px_rgba(181,145,67,0.08)]",

    // Dark header decorative overlays (use as absolutely-positioned spans)
    headerOverlayGlow: "pointer-events-none absolute inset-0 [background:radial-gradient(120%_60%_at_50%_120%,rgba(181,145,67,0.18)_0%,rgba(0,0,0,0)_60%)]",
    headerOverlaySweep: "pointer-events-none absolute -left-10 top-1/2 h-24 w-1/2 -translate-y-1/2 -rotate-6 bg-gradient-to-r from-transparent via-[#FBD282]/14 to-transparent blur-sm",
    headerOverlayTopLine: "pointer-events-none absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#FBD282]/35 to-transparent",
    headerOverlayBottomGlow: "pointer-events-none absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#B59143]/25 to-transparent blur-[2px]",
    
    // Search input classes
    searchInput: isDark
      ? "bg-[#14161B] text-white border-[#2E2F33] placeholder-[#C3C9D3] focus:ring-[#B59143] focus:border-[#B59143]"
      : "bg-white text-[#111827] border-[#E5E7EB] placeholder-gray-500 focus:ring-[#B59143] focus:border-[#B59143]",
  };
};
